import { cloneElement, ReactElement } from 'react';

interface PackageCardProps {
  title?: string;
  value: string;
  icon: ReactElement;
}
export function PackageDetailsItem({ title, value, icon }: PackageCardProps) {
  if (!value) return <></>;

  const sizedIcon = cloneElement(icon, {
    size: 32,
    variant: 'Bulk',
    className: 'text-wl-info-light',
  });

  return (
    <div className='flex gap-2 items-center'>
      {sizedIcon}
      <div className='flex flex-col'>
        {title && (
          <span className='text-R-12 text-wl-on-surface opacity-50'>
            {title}
          </span>
        )}

        <span className='text-M-16 text-wl-on-surface'>{value}</span>
      </div>
    </div>
  );
}
